import {createFormActionTypes} from "../../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../../shared/ts/helpers/create_form_actions";

export const TDA_FILTER_PREFIX = "tda/filter_list";
export const filterTdaListFormTypes = createFormActionTypes(TDA_FILTER_PREFIX);
export const filterTdaListFormActions = createFormActions(filterTdaListFormTypes);
